
import Security from "../company/Security";

export { Page }

function Page() {
  return <Security />;
}
